module.exports = __webpack_public_path__ + "img/CellSystems_Liyuzhe_2024.413a3aee.png";